import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import classNames from "classnames";
import Scrollbar from "react-scrollbars-custom";
import ConvertSvgToComponent from "components/ConvertSvgToComponent";
import { useGlobalContext } from "store/contexts/globalContext";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import logo from "assets/img/reteam_logo.png";
import AppOverviewData from "components/AppOverviewData";
import { useTeamContext } from "store/contexts/teamContext";

export default function Sidebar(props) {
  const { routes, open, closeLeftDrawer } = props;
  const { waterCoolerActivate, handleLogout } = useGlobalContext();
  const teamContext = useTeamContext();
  const team = teamContext?.team || props?.team;
  const [openOverViewM, setOverView] = useState(false);
  const location = useLocation();
  const [activeRoutePath, setActiveRoutePath] = useState("");
  const [linkRoutes, setLinkRoutes] = useState([]);
  const params = useParams();
  const allSidebarFunctions = {
    Logout: handleLogout,
    Overview: handleOverviewFunction,
  };

  function handleOverviewFunction() {
    setOverView(true);
  }

  const handleClose = () => {
    setOverView(false);
  };

  useEffect(() => {
    if (!routes) return;
    
    var routesData = [...routes];
    routesData = routesData.filter((route) => !route.hideFromAllSidebar);

    if (team && team.role_id !== undefined && team.role_id !== 2) {
      routesData = routesData.filter((route) => !route.superAdminOnly);
    }

    if (!props.open) {
      routesData = routesData.filter((route) => !route.hideFromSidebar);
    }

    routesData.forEach((route) => {
      if (route?.path) {
        route.link = route.path;

        Object.keys(params).forEach((key) => {
          const paramValue = params[key];

          route.link = route.link.replace(`:${key}`, paramValue);
        });

      }
    });

    setLinkRoutes(routesData);
    setActiveRoutePath(location.pathname);
    //eslint-disable-next-line
  }, [location, params, props.open, team?.role_id, routes]);

  function activeRoute(routeName) {
    return activeRoutePath.indexOf(routeName) > -1 ? true : false;
  }

  var brand = (
    <Link to={"/"}>
      <p className="navbar-logo mobileSidebarLogo">
        <img className="logo" alt="ReTeam Logo" src={logo} />
      </p>
    </Link>
  );

  const handleSideBarFunction = (name, e) => {
    let functionName = allSidebarFunctions[name];
    functionName(e);
    closeLeftDrawer();
  };

  var links = (
    <div className="timeline-sidebar">
      <ul className="side-menu">
        {params.teamId && (
          <li className="teamNameSidebar">
            <span>{props?.team?.name}</span>
          </li>
        )}
        {linkRoutes.map((prop, key) => {
          var listItemClasses;
          listItemClasses = classNames({
            //eslint-disable-next-line
            [" " + "active"]: activeRoute(
              prop.layout + (prop?.link ?? prop?.path)
            ),
          });

          return (
            <li key={key} className={"left-menu-item" + listItemClasses}>
              {prop.name !== "Sign Out" || !waterCoolerActivate ? (
                <NavLink
                  to={prop.layout + (prop?.link ?? prop.path)}
                  style={{ textDecoration: "none" }}
                  activeClassName="active"
                  onClick={
                    prop?.function &&
                    ((e) => handleSideBarFunction(prop?.functionName, e))
                  }
                >
                  {typeof prop.icon === "string" && (
                    <ConvertSvgToComponent
                      icon={prop.icon}
                      iconHeight={"20px"}
                      imageclass="mw-20"
                    />
                  )}
                  {prop.name}
                </NavLink>
              ) : (
                ""
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );

  return (
    <>
      {props?.team && (
        <div className="col-xl-3 col-lg-3 left-sidebar desktopLeftSidebar">
          <Scrollbar>{links}</Scrollbar>
        </div>
      )}
      <div className="mobileLeftSidebar">
        <Drawer open={open} onClose={closeLeftDrawer} direction="left">
          <div className="col-xl-3 col-lg-3 left-sidebar">
            <Scrollbar style={{ display: "contents" }}>
              {brand}
              {links}
            </Scrollbar>
          </div>
        </Drawer>
      </div>
      <AppOverviewData
        openOverViewM={openOverViewM}
        handleClose={handleClose}
      />
    </>
  );
}
